<template>
  <div>
    <div class="header">
      <div class="container">
        <router-link to="/" replace>
          <img v-if="config.WEB == 3" class="logo" src="../../../assets/images/logo-tz.png" alt="logo" style="height: 40px" />
          <img v-else class="logo" src="../../../assets/images/logo.png" alt="logo" />
        </router-link>
        <div v-if="cityList.length" class="city-list">
          <div v-for="(item, index) in cityList" :key="item.id" class="city" :class="{ active: cityIndex == index && cityList.length > 0 }" @click="changeCity(index)">{{ item.name }}</div>
        </div>
        <div class="nav-box"></div>
        <slot name="message"></slot>
        <template v-if="config.WEB != 4">
          <div v-if="token" class="user">
            <div class="username">{{ userInfo.nickname }}</div>
            <div class="user-drop">
              <img class="user-icon" src="../../../assets/images-front/user-icon.png" alt="user-icon" />
              <div class="drop-box">
                <div v-if="userInfo.user_type == 2" @click="toAdmin" class="drop-item">管理中心</div>
                <div class="drop-item" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
          <div v-else class="no-login">
            <div @click="toLogin" class="login-btn">登录</div>
          </div>
        </template>
      </div>
    </div>
    <el-image v-if="cover" class="banner" :src="cover" fit="cover"></el-image>
    <div v-else class="banner"></div>
  </div>
</template>

<script>
export default {
  props: ['active', 'nav'],

  data() {
    return {
      userInfo: this.$store.getters.userInfo,
      token: this.$store.getters.token,
      cityIndex: 0,
      config: this.config,
    };
  },

  computed: {
    cover() {
      let areaListAll = this.$store.state.user.areaListAll;
      if (!areaListAll.length) {
        return '';
      }
      let index = this.userInfo.level == 1 ? this.cityIndex : 0;
      return areaListAll[0].child[index].ext.cover_img_preview;
    },
    cityList() {
      let areaListAll = this.$store.state.user.areaListAll;
      if (!areaListAll.length) {
        return [];
      }
      return this.userInfo.level == 3 ? [] : areaListAll[0].child;
    },
    cityListFilter() {
      return this.cityList.filter((item) => this.cityList[this.cityIndex].id != item.id);
    },
  },

  methods: {
    changeCity(index) {
      this.cityIndex = index;
      this.$emit('change', this.cityList[this.cityIndex].child);
    },

    //退出登录
    async logout() {
      try {
        await this.$confirm('确认退出登录么?', '提示', { type: 'warning' });
        this.$store.dispatch('user/logout');
      } catch (e) {
        console.error(e);
      }
    },

    toLogin() {
      this.$router.push(`/login?forward=${encodeURIComponent(location.href)}`);
    },

    toAdmin() {
      this.$router.push(this.$store.getters.routes[0].path);
    },
  },
};
</script>

<style scoped>
.header {
  color: #fff;
  font-size: 18px;
  position: fixed;
  width: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
}

.container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 80px;
}

.logo {
  display: block;
  height: 60px;
}

.nav-box {
  display: flex;
  align-items: center;
  margin-left: 50px;
  flex: 1;
}

.user {
  display: flex;
  align-self: center;
  position: relative;
  height: 100%;
  justify-content: flex-end;
}

.username {
  display: flex;
  align-items: center;
}

.user-icon {
  display: block;
  width: 22px;
  height: 23px;
  margin-left: 22px;
  cursor: pointer;
}

.user-drop {
  display: flex;
  align-items: center;
  position: relative;
}

.user-drop .drop-box {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 180px;
  background: rgba(255, 255, 255);
  display: none;
}

.user-drop .drop-box .drop-item {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  text-decoration: none;
}

.user-drop .drop-box .drop-item:hover {
  background: linear-gradient(to bottom, #3e90ff, #1571ee);
  color: #fff;
}

.user:hover .drop-box {
  display: block;
}

.no-login {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.login-btn {
  width: 75px;
  height: 30px;
  color: #fff;
  border-radius: 20px;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.city-list {
  margin-left: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.city-list .city {
  display: flex;
  align-items: center;
  margin-right: 30px;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
.city-list .city.active {
  font-size: 16px;
}

.city-list .city.active:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 2px;
  background: #fff;
}

.city-list .city .iconfont {
  margin-left: 10px;
  font-size: 12px;
  transition: all 0.3s ease;
}

.city-list .drop-box {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 180px;
  background: rgba(255, 255, 255);
  display: none;
}

.city-list .drop-item {
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  text-decoration: none;
}

.city-list .drop-box .drop-item:hover {
  color: #1571ee;
}

.city-list:hover .drop-box {
  display: block;
}

.city-list:hover .icon-arrow-bottom {
  transform: rotate(-180deg);
}

.banner {
  display: block;
  height: 500px;
  width: 100%;
  background: #f5f7fa;
}
</style>
